import { Navigate, Outlet } from "react-router";
import { useMe } from "../../hooks/useMe";

/**
 * Route guard that only allows unauthenticated users through.
 * Redirects logged-in users to their role-appropriate default page.
 * Wrap routes that guests (non-logged-in users) should access (login, register).
 */
export const RequireGuest = () => {
  const { user, appConfig, loading } = useMe();

  // Wait for the auth check to complete — don't flash login then redirect
  if (loading) return null;

  // Logged in → redirect to their default page
  if (user) {
    return <Navigate to={appConfig?.defaultPage ?? "/profile"} replace />;
  }

  // Not logged in → render the guest page (login/register)
  return <Outlet />;
};
